export default {"src":"/_next/static/media/feature_1.85e44dfd.svg","height":85,"width":100,"blurWidth":0,"blurHeight":0};